import Routes from "@/routes";
import Vue from "vue";
import Router, { Route } from "vue-router";
import { SecurityService } from "@/services/SecurityService";
import store from "@/store/index";
import { msalService } from "./auth/msalService";

Vue.use(Router);

const router: Router = new Router({
  routes: Routes.constructAll(),
});

router.beforeEach(async (to, from, next) => {
  if (store.getters.authenticationConfiguration.authenticationType === "msal") {
    // 🔥 ensure redirect processing is done
    await msalService.initialize();
    const account = msalService.getAccount();
    if (to.meta.requiresAuth && !account) {
      // 🔥 Redirect to login page — MSAL will redirect again to Azure AD
      return msalService.loginRedirect();
    }
  }

  // Ensure permissions are loaded before checking them
  const userPermissions = store.getters.userPermissions;
  if (!userPermissions.view && !userPermissions.patientTransporterView) {
    // Permissions not loaded yet - load them first
    try {
      await store.dispatch("loadPermissions");
    } catch (error) {
      console.error("Failed to load permissions in router guard:", error);
      // Continue anyway - default permissions will be used
    }
  }

  const requiresZorgIdAuth = to.matched.some(
    record => record.meta.requiresZorgIdAuth,
  );
  const requiresProfessionalSummaryEnabled = to.matched.some(
    record => record.meta.requiresProfessionalSummaryEnabled,
  );
  const restrictedForPatientTransporters = to.matched.some(
    record => record.meta.restrictedForPatientTransporters,
  );
  const professionalSummaryEnabled =
    store.getters.applicationConfiguration.professionalSummaryEnabled;

  // Check authentication
  if (requiresZorgIdAuth && !SecurityService.getInstance().isLoggedOn()) {
    next("/ZorgID/Logon?returnUrl=" + encodeURIComponent(to.path));
    return;
  }

  // Check feature flag for professional summary
  if (requiresProfessionalSummaryEnabled && !professionalSummaryEnabled) {
    next("/"); // Redirect to home if feature is not enabled
    return;
  }

  // Block patient transporters from accessing restricted routes (detail pages)
  if (restrictedForPatientTransporters && userPermissions.patientTransporterView) {
    next("/"); // Redirect to home (actuele meldingen)
    return;
  }

  next(); // Proceed if all checks pass
});

export default router;
